module.exports = __webpack_public_path__ + "media/images/level_introduction2-2b0ad9a54822da34b5fe3b6b658f91be.png";